<template>
  <v-data-table
    :headers="headers"
    :items="surgeryIntraoperativeSurgeryTemplates"
    sort-by="name"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialog" max-width="800px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Nova descrição
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.name"
                      label="Nome"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <RichText v-model="editedItem.description" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_hma"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hma"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há modelos cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "TemplateList",
    props: {
      surgeryIntraoperativeSurgery: Object,
    },
    data() {
      return {
        dialog: null,
        editedItem: {},
        defaultItem: {},
        editedIndex: -1,
        headers: [
          { text: "Name", value: "name" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
        surgeryIntraoperativeSurgeryTemplates: [],
      };
    },
    mounted() {
      this.surgeryIntraoperativeSurgeryTemplates = [];
    },
    watch: {
      surgeryIntraoperativeSurgery() {
        this.surgeryIntraoperativeSurgeryTemplates = [];
      },
    },
    apollo: {
      surgeryIntraoperativeSurgeryTemplates: {
        query: require("@/graphql/surgery/surgery_intraoperative_surgery_templates.gql"),
        variables() {
          return {
            surgeryIntraoperativeSurgeryId: this.surgeryIntraoperativeSurgery.id,
          };
        },
        pollInterval: 20000,
        skip() {
          return !this.surgeryIntraoperativeSurgery?.id;
        },
      },
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Novo Modelo" : "Editar Modelo";
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.surgeryIntraoperativeSurgeryTemplates.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse técnica?")) {
          this.apolloMutate({
            mutation: require("@/graphql/surgery/delete_surgery_intraoperative_surgery_template.gql"),
            variables: {
              surgeryIntraoperativeSurgeryTemplateId: item.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Descrição cirurgica deletada com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        this.apolloMutate({
          mutation: require("@/graphql/surgery/save_surgery_intraoperative_surgery_template.gql"),
          variables: {
            surgeryIntraoperativeSurgeryTemplateId: this.lodash.get(this.editedItem, "id", ""),
            surgeryIntraoperativeSurgeryId: this.surgeryIntraoperativeSurgery.id,
            name: this.editedItem.name,
            description: this.editedItem.description,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      refreshList() {
        return this.$apollo.queries.surgeryIntraoperativeSurgeryTemplates.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
